import QuestionType from './question/questionType/questionType';
import TypeAuthSelect from './question/questionType/typeAuthSelect';
import TypeAuth from './question/questionType/typeAuth';
import QuestionTypeFileImport from './question/questionType/questionTypeFileImport';
import SurveyManager from './survey/surveyManager';
import SurveyDetail from './survey/surveyDetail/surveyDetail';
import SurveyQuestionDetail from './survey/surveyQuestionDetail/surveyQuestionDetail'
import SurveyPreview from './survey/surveyPreview/surveyPreview'
import SurveyTemplateManager from './surveyTemplate/surveyTemplateManager';
import SurveyTemplateDetail from './surveyTemplate/surveyTemplateDetail/surveyTemplateDetail';
import SurveyRecordInfo from './survey/surveyRecordInfo/surveyRecordInfo';
import SurveyRecordInfoDetail from './survey/surveyRecordInfo/surveyRecordInfoDetail';
import SurveyTemplatePreview from './surveyTemplate/surveyTemplatePreview/surveyTemplatePreview';
import SurveyAuth from './survey/surveyAuth/surveyAuth';
import SurveyAuthSelect from './survey/surveyAuth/surveyAuthSelect';
import Comment from './comment';
import OperateRecord from './operateRecord'
import Featured from './featured/featured'
import FeaturedDetail from './featured/featuredDetail/featuredDetail'
import FeaturedLook from './featured/look'
import SeriesProgram from './seriesProgram/questionType';
import InviteLetterManager from './inviteLetter/index'
import InviteLetterEdit from './inviteLetter/edit/inviteLetterEdit'
import LabelManager from './label/index'
import LabelDetail from './label/detail/detail'
import LabelView from './label/viewLabel/viewLabel'
import LabelRule from './label/rule/rule'
import LabelFeatureContent from './label/featureContent/featureContent'
import LabelUser from './label/user/index'
import LabelUserLook from './label/user/look'
import LabelUserImport from './label/user/userImport'

export {
  QuestionType,
  QuestionTypeFileImport,
  TypeAuthSelect,
  TypeAuth,
  SurveyManager,
  SurveyDetail,
  SurveyQuestionDetail,
  SurveyPreview,
  SurveyTemplateManager,
  SurveyTemplateDetail,
  SurveyRecordInfo,
  SurveyRecordInfoDetail,
  SurveyTemplatePreview,
  SurveyAuth,
  SurveyAuthSelect,
  Comment,
  OperateRecord,
  Featured,
  FeaturedDetail,
  FeaturedLook,
  SeriesProgram,
  InviteLetterManager,
  InviteLetterEdit,
  LabelManager,
  LabelDetail,
  LabelView,
  LabelRule,
  LabelFeatureContent,
  LabelUser,
  LabelUserLook,
  LabelUserImport
}
